import type { PlaceCategory } from '@/types';

export function getCategoryIcon(category: PlaceCategory): string {
  const icons: Record<PlaceCategory, string> = {
    restaurant: '🍽️',
    cafe: '☕',
    bar: '🍺',
    hotel: '🏨',
    gas_station: '⛽',
    parking: '🅿️',
    hospital: '🏥',
    pharmacy: '💊',
    bank: '🏦',
    atm: '💳',
    supermarket: '🛒',
    shopping: '🛍️',
    entertainment: '🎭',
    museum: '🏛️',
    park: '🌳',
    beach: '🏖️',
    airport: '✈️',
    train_station: '🚂',
    bus_station: '🚌',
    school: '🏫',
    university: '🎓',
    library: '📚',
    gym: '💪',
    police: '👮',
    fire_station: '🚒',
    post_office: '📮',
    ev_charging: '🔌',
    other: '📍',
  };

  return icons[category] || icons.other;
}

export function getCategoryLabel(category: PlaceCategory): string {
  const labels: Record<PlaceCategory, string> = {
    restaurant: 'Restaurant',
    cafe: 'Cafe',
    bar: 'Bar',
    hotel: 'Hotel',
    gas_station: 'Gas Station',
    parking: 'Parking',
    hospital: 'Hospital',
    pharmacy: 'Pharmacy',
    bank: 'Bank',
    atm: 'ATM',
    supermarket: 'Supermarket',
    shopping: 'Shopping',
    entertainment: 'Entertainment',
    museum: 'Museum',
    park: 'Park',
    beach: 'Beach',
    airport: 'Airport',
    train_station: 'Train Station',
    bus_station: 'Bus Station',
    school: 'School',
    university: 'University',
    library: 'Library',
    gym: 'Gym',
    police: 'Police',
    fire_station: 'Fire Station',
    post_office: 'Post Office',
    ev_charging: 'EV Charging',
    other: '',
  };

  return labels[category] || '';
}

export function getCategoryColor(category: PlaceCategory): string {
  const colors: Record<PlaceCategory, string> = {
    restaurant: '#ea4335',
    cafe: '#8b4513',
    bar: '#9c27b0',
    hotel: '#3f51b5',
    gas_station: '#ff9800',
    parking: '#2196f3',
    hospital: '#f44336',
    pharmacy: '#4caf50',
    bank: '#607d8b',
    atm: '#009688',
    supermarket: '#8bc34a',
    shopping: '#e91e63',
    entertainment: '#673ab7',
    museum: '#795548',
    park: '#4caf50',
    beach: '#00bcd4',
    airport: '#3f51b5',
    train_station: '#ff5722',
    bus_station: '#ff9800',
    school: '#2196f3',
    university: '#3f51b5',
    library: '#795548',
    gym: '#f44336',
    police: '#3f51b5',
    fire_station: '#f44336',
    post_office: '#ff9800',
    ev_charging: '#4caf50',
    other: '#9e9e9e',
  };

  return colors[category] || colors.other;
}

export function getPlaceCategories(): { value: PlaceCategory; label: string; icon: string }[] {
  return [
    { value: 'restaurant', label: 'Restaurants', icon: getCategoryIcon('restaurant') },
    { value: 'cafe', label: 'Cafes', icon: getCategoryIcon('cafe') },
    { value: 'bar', label: 'Bars', icon: getCategoryIcon('bar') },
    { value: 'hotel', label: 'Hotels', icon: getCategoryIcon('hotel') },
    { value: 'gas_station', label: 'Gas Stations', icon: getCategoryIcon('gas_station') },
    { value: 'parking', label: 'Parking', icon: getCategoryIcon('parking') },
    { value: 'hospital', label: 'Hospitals', icon: getCategoryIcon('hospital') },
    { value: 'pharmacy', label: 'Pharmacies', icon: getCategoryIcon('pharmacy') },
    { value: 'supermarket', label: 'Supermarkets', icon: getCategoryIcon('supermarket') },
    { value: 'shopping', label: 'Shopping', icon: getCategoryIcon('shopping') },
    { value: 'park', label: 'Parks', icon: getCategoryIcon('park') },
    { value: 'museum', label: 'Museums', icon: getCategoryIcon('museum') },
    { value: 'airport', label: 'Airports', icon: getCategoryIcon('airport') },
    { value: 'train_station', label: 'Train Stations', icon: getCategoryIcon('train_station') },
  ];
}
